import React from 'react'
import { ProgramsType } from '../../Launch/launchProgramsSlice'
import styled from '@emotion/styled'
import palette from 'core-system/Themes/palette'
import launchProgramsWordings from '../../Shared/wordings.json'
import Text from 'core-system/Text/Text'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

const AccordionContainer = styled(Accordion)`
  padding: 1rem;
  border: 1px solid ${palette.grey.grey300};
  border-radius: 0.5rem !important;
  background-color: ${palette.primary.pink50};
  box-shadow: 0 0 0 0 !important;
  margin-bottom: 1rem !important;
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
`

const AccordionDetailsContainer = styled(AccordionDetails)`
  padding: 2rem 1rem;
`

const TitleIconContainer = styled.div`
  display: flex;
  gap: 0.75rem;
`

interface ProgramEditSectionProps {
  program: ProgramsType
  children: React.ReactNode
  icon: React.ReactNode
}

const ProgramEditSection = ({
  program,
  children,
  icon,
}: ProgramEditSectionProps) => {
  return (
    <AccordionContainer defaultExpanded>
      <AccordionSummary
        expandIcon={
          <KeyboardArrowDownIcon
            sx={{ color: palette.primary.pink800, fontSize: '2rem' }}
          />
        }
      >
        <TitleContainer>
          <TitleIconContainer>
            {icon}
            <Text variant='h4' marginBottom='0.925rem'>
              {launchProgramsWordings[program].title}
            </Text>
          </TitleIconContainer>
          <Text variant='body1' color={palette.text.secondary}>
            {launchProgramsWordings[program].subtitle}
          </Text>
        </TitleContainer>
      </AccordionSummary>
      <AccordionDetailsContainer>{children}</AccordionDetailsContainer>
    </AccordionContainer>
  )
}

export default React.memo(ProgramEditSection)
